import { MedChronRequestStatus } from "@/constants";
import { z } from "zod";

export const ChronologyRunResponseSchema = z.object({
  request_id: z.string().uuid(),
  status: z.nativeEnum(MedChronRequestStatus),
});

export type ChronologyRunResponse = z.infer<typeof ChronologyRunResponseSchema>;

export interface MarkCaseReviewedResponse {
  status: "success";
}

export interface CaseDetailsResponse {
  case_id: string;
  case_name: string;
  exam_dt: string | null;
  due_date: string | null;
  status_id: number;
  physician_id: string | null;
  physician_name: string | null;
}

export interface UpdateCasePhysicianResponse {
  physician_id: string;
  physician_name: string | null;
}

/** A user assigned to a case — same shape for analysts and QC reviewers. */
export interface CaseUser {
  user_id: string;
  name: string;
}

export interface CaseUnresolvedErrorDetails {
  message?: string;
  recommended_action?: string;
}

export interface CaseUnresolvedError {
  description: string;
  error_details: CaseUnresolvedErrorDetails;
  created_at: string;
}

export interface CaseListItem {
  case_id: string;
  case_name: string;
  exam_date: string | null;
  due_date: string | null;
  physician: string | null;
  physician_id: string | null;
  analysts: CaseUser[];
  qc_reviewers?: CaseUser[];
  status_id: number;
  files: number;
  pages: number;
  unresolved_errors: CaseUnresolvedError[];
  ai_review_status: string | null;
  created_at: string;
  firm_id?: string;
  firm_name?: string;
}

export interface CreateCaseResponse {
  case_id: string;
  case_name: string;
  user_id: string;
  firm_id: string;
  status_id: number;
  is_deleted: boolean;
  created_at: string;
}
